import { ADFState, UserState } from "./user-state";
import { UserAction, UserActionTypeEnum } from "./user-action"

const initialState: UserState = {
    invalidOTL: false,
    userLogOut: false,
    userAuthenticated: false,
    userInactivelyLoggedOut: false,
    email: '',
    firstName: '',
    lastName: '',
    countryCode: '',
    mobileNumber: '',
    companyName: '',
    countryOfIncorporation: '',
    legalDisclaimerAccepted: false,
    user_role: '',
    userTeamCodes:[],
    actions: null,
    userId: '',
    fenergoUserId: '',
    portfolioId: '',
    userCompanies: [],
}

export const userReducer = (
    state: UserState = initialState,
    action: UserAction
): UserState => {
    switch (action.type) {
        case UserActionTypeEnum.SET_PORTFOLIO_TEAM_CODE: {
            return {
                ...state,
                userTeamCodes: action.userTeamCodes
            }
        }
        case UserActionTypeEnum.SET_PORTFOLIO_ID: {
            return {
                ...state,
                portfolioId: action.portfolioId
            }
        }
        case UserActionTypeEnum.SET_PORTFOLIO_COMPANIES: {
            return {
                ...state,
                userCompanies: action.userCompanies
            }
        }
        case UserActionTypeEnum.INVALID_OTL: {
            return {
                ...state,
                invalidOTL: action.invalidOTL
            }
        }
        case UserActionTypeEnum.USER_LOGOUT: {
            return {
                ...state,
                userLogOut: action.userLogOut,
                userInactivelyLoggedOut: action.userInactivelyLoggedOut,
                userAuthenticated: false
            }
        }
        case UserActionTypeEnum.USER_AUTHENTICATED: {
            return {
                ...state,
                userAuthenticated: action.userAuthenticated
            }
        }
        case UserActionTypeEnum.SET_USER: {
            return { 
                ...action.user
            }
        }
        case UserActionTypeEnum.SAVE_EMAIL: {
            return {
                ...state,
                email: action.email
            }
        }
        case UserActionTypeEnum.LEGAL_DISCLAIMER_ACCEPTED: {
            return {
                ...state,
                legalDisclaimerAccepted: action.accepted
            }
        }
        case UserActionTypeEnum.SAVE_USER_INFO: {
            return {
                ...state,
                firstName: action.userInfo.contact_given_name,
                lastName: action.userInfo.contact_last_name,
                email: action.userInfo.user_email,
                user_role: action.userInfo.user_role,
                actions: action.userInfo.actions,
                userId: action.userInfo.user_id,
                fenergoUserId: action.userInfo.fenergo_user_id,
            }
        }
        default: {
            return {
                ...state
            };
        }
    }
}

export default userReducer